'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ProductItem = require('../components/ProductItem');

var _ProductItem2 = _interopRequireDefault(_ProductItem);

var _RTE = require('../components/RTE');

var _RTE2 = _interopRequireDefault(_RTE);

var _EventHandler = require('../utils/EventHandler');

var _EventHandler2 = _interopRequireDefault(_EventHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DynamicCollection = function () {
  function DynamicCollection(section) {
    var _this = this;

    (0, _classCallCheck3.default)(this, DynamicCollection);

    this.el = section.el;
    this.ev = new _EventHandler2.default();
    this.productEls = this.el.querySelectorAll('[data-product-item]');
    this.products = [];
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];
    this.toggles = this.el.querySelectorAll('.collection-toggle--link');

    for (var i = 0; i < this.productEls.length; i++) {
      this.products.push(new _ProductItem2.default(this.productEls[i]));
    }

    for (var _i = 0; _i < this.rteEls.length; _i++) {
      this.rtes.push(new _RTE2.default(this.rteEls[_i]));
    }

    this.toggles.forEach(function (el) {
      _this.ev.register(el, 'click', function (e) {
        var collectionNum = e.currentTarget.dataset.collection;
        _this.el.querySelectorAll('[data-collection].active').forEach(function (match) {
          return match.classList.remove('active');
        });
        _this.el.querySelectorAll('[data-collection="' + collectionNum + '"]').forEach(function (match) {
          return match.classList.add('active');
        });
      });
    });
  }

  (0, _createClass3.default)(DynamicCollection, [{
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      this.ev.unregisterAll();
      this.products.forEach(function (product) {
        return product.unload();
      });
      this.rtes.forEach(function (rte) {
        return rte.unload();
      });
    }
  }]);
  return DynamicCollection;
}();

exports.default = DynamicCollection;